export const USE_MOCK = false;

export function formatAmount(value) {
  const n = Number(value) || 0;
  if (n >= 100000000) return `${(n / 100000000).toFixed(2)}亿`;
  if (n >= 10000) return `${(n / 10000).toFixed(1)}万`;
  return `${n.toLocaleString()}元`;
}

/** 顶部 KPI */
export function mockOverview() {
  return {
    year: 2026,
    tracking_count: 86,
    tracking_amount: 428600000,
    work_amount: 171700000,
    opened_amount: 125300000,
    win_amount: 45200000,
    active_work: 24,
    urgent_work: 4,
    opened_count: 26,
    win_count: 9,
    win_rate: 34.6,
    bond_pending: 6,
    bond_amount: 680000,
    new_this_month: 8,
    yoy_growth: 12.5,
    info_count: 18,
    work_total: 39,
    waiting_open: 6,
    pending_audit: 6,
  };
}

/** 三阶段漏斗 */
export function mockPipeline() {
  return {
    stages: [
      {
        key: 'info',
        name: '投标分析',
        route: 'info',
        icon: 'md-analytics',
        count: 18,
        amount: 126000000,
        desc: '机会识别与立项评审',
        subs: [
          {name: '审核中', count: 6},
          {name: '审核通过', count: 9},
          {name: '准备中', count: 3},
        ],
      },
      {
        key: 'work',
        name: '投标工作',
        route: 'work',
        icon: 'md-hammer',
        count: 39,
        amount: 171700000,
        desc: '标书编制与投标准备',
        subs: [
          {name: '进行中', count: 24},
          {name: '已投标', count: 15},
        ],
        convert_rate: 72,
      },
      {
        key: 'open',
        name: '开标情况',
        route: 'open',
        icon: 'md-clipboard',
        count: 26,
        amount: 125300000,
        desc: '开标登记与结果跟踪',
        subs: [
          {name: '已中标', count: 9},
          {name: '未中标', count: 17},
        ],
        convert_rate: 35,
      },
    ],
  };
}

export function mockCharts(type) {
  const raw = {
    scale: [
      {name: '50万以下', value: 12},
      {name: '50-100万', value: 18},
      {name: '100-500万', value: 26},
      {name: '500-1000万', value: 14},
      {name: '1000万以上', value: 8},
    ],
    location: [
      {name: '海曙区', value: 22},
      {name: '江北区', value: 15},
      {name: '镇海区', value: 12},
      {name: '北仑区', value: 18},
      {name: '鄞州区', value: 11},
      {name: '其他', value: 8},
    ],
    type: [
      {name: '全过程咨询', value: 28},
      {name: '房建监理', value: 21},
      {name: '市政监理', value: 16},
      {name: '造价咨询', value: 9},
      {name: '招标代理', value: 6},
      {name: '其他', value: 6},
    ],
    trend: [
      {name: '1月', bid_count: 14, win_count: 5, win_amount: 3200000},
      {name: '2月', bid_count: 16, win_count: 6, win_amount: 4100000},
      {name: '3月', bid_count: 18, win_count: 7, win_amount: 5800000},
      {name: '4月', bid_count: 22, win_count: 8, win_amount: 7200000},
      {name: '5月', bid_count: 26, win_count: 9, win_amount: 8600000},
      {name: '6月', bid_count: 20, win_count: 7, win_amount: 6500000},
      {name: '7月', bid_count: 24, win_count: 10, win_amount: 9800000},
      {name: '8月', bid_count: 19, win_count: 6, win_amount: 5400000},
      {name: '9月', bid_count: 21, win_count: 8, win_amount: 7600000},
      {name: '10月', bid_count: 23, win_count: 9, win_amount: 8200000},
      {name: '11月', bid_count: 17, win_count: 5, win_amount: 4800000},
      {name: '12月', bid_count: 15, win_count: 4, win_amount: 3600000},
    ],
    result: [
      {name: '已中标', value: 9},
      {name: '未中标', value: 17},
      {name: '流标', value: 2},
      {name: '待定', value: 3},
    ],
    status: [
      {name: '标书撰写', value: 8},
      {name: '内部审核', value: 5},
      {name: '人员选配', value: 4},
      {name: '已投标', value: 15},
      {name: '准备中', value: 7},
    ],
  };
  return raw[type] || raw.scale;
}

/** 三模块详情 — 每模块 10 条 */
function padItems(items, n = 10) {
  return items.length >= n ? items.slice(0, n) : items;
}

export function mockModules() {
  return {
    info: {
      route: 'info',
      title: '投标分析',
      icon: 'md-analytics',
      summary: {count: 18, amount: 126000000, pending_audit: 6},
      items: padItems([
        {id: 1, name: '工业互联网研究院全过程咨询', status: '审核通过', amount: 8600000, date: '05/21'},
        {id: 2, name: '北仑区文化中心项目管理', status: '审核中', amount: 18600000, date: '05/20'},
        {id: 3, name: '映荷佳苑二期监理服务', status: '准备中', amount: 4200000, date: '05/18'},
        {id: 4, name: '广电融媒体科技创新大厦', status: '审核通过', amount: 19800000, date: '05/17'},
        {id: 5, name: '宁大宿舍扩建工程监理', status: '审核中', amount: 2740000, date: '05/16'},
        {id: 6, name: '市政道路改造全过程咨询', status: '准备中', amount: 6500000, date: '05/15'},
        {id: 7, name: '高新区产业园监理', status: '审核通过', amount: 9200000, date: '05/14'},
        {id: 8, name: '东钱湖片区造价咨询', status: '审核中', amount: 3100000, date: '05/13'},
        {id: 9, name: '奉化区医院迁建监理', status: '准备中', amount: 9600000, date: '05/12'},
        {id: 10, name: '轨道交通配套全过程', status: '审核通过', amount: 15200000, date: '05/11'},
      ]),
    },
    work: {
      route: 'work',
      title: '投标工作',
      icon: 'md-hammer',
      summary: {count: 39, amount: 171700000, urgent: 4},
      items: padItems([
        {id: 11, name: '新材料科技城监理项目', status: '标书撰写', amount: 21700000, date: '05/22', urgent: true},
        {id: 12, name: '高新区智慧园区全过程', status: '内部审核', amount: 12800000, date: '05/22'},
        {id: 13, name: '奉化区医院迁建监理', status: '人员选配', amount: 9600000, date: '05/21'},
        {id: 14, name: '轨道交通站点配套监理', status: '业绩准备', amount: 7300000, date: '05/20', urgent: true},
        {id: 15, name: '某学校改扩建工程', status: '工作分配', amount: 5100000, date: '05/19'},
        {id: 16, name: '港口物流园造价咨询', status: '标书撰写', amount: 2800000, date: '05/18'},
        {id: 17, name: '城市更新片区监理', status: '内部审核', amount: 8400000, date: '05/17'},
        {id: 18, name: '保障性住房二标段', status: '标书撰写', amount: 6100000, date: '05/16'},
        {id: 19, name: '工业厂房扩建监理', status: '已投标', amount: 2900000, date: '05/15'},
        {id: 20, name: '河道整治工程监理', status: '已投标', amount: 4800000, date: '05/14'},
      ]),
    },
    open: {
      route: 'open',
      title: '开标情况',
      icon: 'md-clipboard',
      summary: {count: 26, amount: 125300000, win_rate: 34.6, exception: 2},
      items: padItems([
        {id: 21, name: '宁大附属实验学校监理', status: '已中标', amount: 5680000, date: '05/20'},
        {id: 22, name: '东钱湖旅游配套全过程', status: '已中标', amount: 15200000, date: '05/15'},
        {id: 23, name: '产业园标准厂房监理', status: '已中标', amount: 3900000, date: '05/10'},
        {id: 24, name: '城市更新片区造价咨询', status: '已中标', amount: 2200000, date: '05/08'},
        {id: 31, name: '某综合体全过程咨询', status: '未中标', amount: 22000000, date: '05/19'},
        {id: 32, name: '保障性住房监理二标段', status: '未中标', amount: 6100000, date: '05/17'},
        {id: 33, name: '市政管网改造监理', status: '未中标', amount: 3500000, date: '05/14'},
        {id: 34, name: '工业厂房扩建监理', status: '未中标', amount: 2900000, date: '05/12'},
        {id: 35, name: '招标代理服务采购', status: '未中标', amount: 800000, date: '05/09'},
        {id: 36, name: '某学校监理项目', status: '已中标', amount: 4200000, date: '05/06'},
      ]),
    },
  };
}

export function mockBonds() {
  return {
    total: 7,
    total_amount: 780000,
    list: [
      {id: 1, name: '某综合体全过程咨询', deposit_amount: 200000, bid_result: '未中标', deadline: '2026-05-18', overdue_days: 4, district: '鄞州区'},
      {id: 2, name: '保障性住房监理二标段', deposit_amount: 100000, bid_result: '未中标', deadline: '2026-05-15', overdue_days: 7, district: '江北区'},
      {id: 3, name: '市政管网改造监理', deposit_amount: 80000, bid_result: '未中标', deadline: '2026-05-20', overdue_days: 2, district: '海曙区'},
      {id: 4, name: '工业厂房扩建监理', deposit_amount: 100000, bid_result: '未中标', deadline: '2026-05-22', overdue_days: 0, district: '北仑区'},
      {id: 5, name: '招标代理服务采购', deposit_amount: 100000, bid_result: '未中标', deadline: '2026-05-25', overdue_days: 0, district: '镇海区'},
      {id: 6, name: '东钱湖片区造价咨询', deposit_amount: 100000, bid_result: '未中标', deadline: '2026-05-26', overdue_days: 0, district: '鄞州区'},
      {id: 7, name: '宁大宿舍扩建工程监理', deposit_amount: 100000, bid_result: '未中标', deadline: '2026-05-27', overdue_days: 0, district: '江北区'},
    ],
  };
}

/** 投标截止临近预警 */
export function mockDeadlines() {
  return {
    total: 7,
    list: [
      {id: 101, name: '新材料科技城监理项目', bid_deadline: '2026-05-23', days_left: 1, amount: 21700000, assignee: '王明'},
      {id: 102, name: '轨道交通站点配套监理', bid_deadline: '2026-05-24', days_left: 2, amount: 7300000, assignee: '陈静'},
      {id: 103, name: '高新区智慧园区全过程', bid_deadline: '2026-05-25', days_left: 3, amount: 12800000, assignee: '李华'},
      {id: 104, name: '保障性住房二标段', bid_deadline: '2026-05-27', days_left: 5, amount: 6100000, assignee: '张伟'},
      {id: 105, name: '港口物流园造价咨询', bid_deadline: '2026-05-28', days_left: 6, amount: 2800000, assignee: '赵强'},
      {id: 106, name: '城市更新片区监理', bid_deadline: '2026-05-29', days_left: 7, amount: 8400000, assignee: '刘洋'},
      {id: 107, name: '奉化区医院迁建监理', bid_deadline: '2026-05-30', days_left: 8, amount: 9600000, assignee: '周敏'},
    ],
  };
}

export function mockActivities() {
  return [
    {id: 1, module: 'work', user_name: '王明', summary: '更新进度为「标书撰写」', project_name: '宁波新材料科技城监理项目', formatted_time: '35分钟前'},
    {id: 2, module: 'open', user_name: '李华', summary: '登记开标结果：已中标', project_name: '宁波大学附属实验学校监理', formatted_time: '1小时前'},
    {id: 3, module: 'info', user_name: '张伟', summary: '新建投标分析项目', project_name: '奉化区医院迁建监理', formatted_time: '昨天 16:20'},
    {id: 4, module: 'work', user_name: '陈静', summary: '创建投标工作安排', project_name: '轨道交通站点配套监理', formatted_time: '昨天 14:05'},
    {id: 5, module: 'open', user_name: '赵强', summary: '登记保证金缴纳 10万元', project_name: '某学校改扩建工程', formatted_time: '昨天 11:30'},
    {id: 6, module: 'open', user_name: '刘洋', summary: '登记未中标，综合排名第3', project_name: '某综合体全过程咨询', formatted_time: '05/20 17:00'},
    {id: 7, module: 'work', user_name: '周敏', summary: '提交内部审核', project_name: '高新区智慧园区全过程', formatted_time: '05/20 15:20'},
    {id: 8, module: 'info', user_name: '吴磊', summary: '审核通过立项', project_name: '北仑区文化中心项目管理', formatted_time: '05/20 10:45'},
    {id: 9, module: 'work', user_name: '郑洁', summary: '完成标书初稿', project_name: '保障性住房二标段', formatted_time: '05/19 18:30'},
    {id: 10, module: 'open', user_name: '孙浩', summary: '登记开标时间', project_name: '工业厂房扩建监理', formatted_time: '05/19 09:15'},
  ];
}

/** 已投标、等待开标 */
export function mockWaitingOpen() {
  return {
    total: 7,
    list: [
      {id: 201, name: '工业厂房扩建监理', open_date: '2026-05-26', days_left: 4, amount: 2900000},
      {id: 202, name: '河道整治工程监理', open_date: '2026-05-27', days_left: 5, amount: 4800000},
      {id: 203, name: '某学校改扩建工程', open_date: '2026-05-28', days_left: 6, amount: 5100000},
      {id: 204, name: '港口物流园造价咨询', open_date: '2026-05-29', days_left: 7, amount: 2800000},
      {id: 205, name: '城市更新片区监理', open_date: '2026-05-30', days_left: 8, amount: 8400000},
      {id: 206, name: '保障性住房二标段', open_date: '2026-06-02', days_left: 11, amount: 6100000},
      {id: 207, name: '轨道交通配套全过程', open_date: '2026-06-03', days_left: 12, amount: 15200000},
    ],
  };
}

/** 项目列表 Tab 兜底（接口失败时） */
export function mockProjects(tab = 'analysis') {
  const mods = mockModules();
  if (tab === 'analysis') {
    return mods.info.items.map((i) => ({...i, date: `2026-${i.date.replace('/', '-')}`}));
  }
  if (tab === 'bidding') {
    return mods.work.items
      .filter((i) => i.status !== '已投标')
      .map((i) => ({...i, date: `2026-${i.date.replace('/', '-')}`, charger: ''}));
  }
  if (tab === 'won') {
    return mods.open.items
      .filter((i) => i.status === '已中标')
      .map((i) => ({...i, date: `2026-${i.date.replace('/', '-')}`}));
  }
  return mods.open.items
    .filter((i) => i.status === '未中标')
    .map((i) => ({...i, date: `2026-${i.date.replace('/', '-')}`}));
}

export const MODULE_LABELS = {
  info: '分析',
  work: '工作',
  open: '开标',
};

export const STATUS_STYLE = {
  '审核通过': 'done',
  '审核中': 'active',
  '准备中': 'idle',
  '标书撰写': 'active',
  '内部审核': 'active',
  '人员选配': 'active',
  '业绩准备': 'active',
  '工作分配': 'idle',
  '已投标': 'done',
  '已中标': 'done',
  '未中标': 'idle',
};
